import { useNavigate } from "react-router-dom";

export const HomeFooter = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="/maia_logo_white.svg" 
              alt="Maia Logo"
              className="h-8 w-auto mb-4" 
            />
            <p className="text-sm text-white/80">
              Maia is the best AI-powered email assistance for professionals and teams
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Features</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li className="cursor-pointer hover:text-white" onClick={() => scrollToSection("features")}>
                Features Overview
              </li>
              <li className="cursor-pointer hover:text-white" onClick={() => scrollToSection("human-loop")}>
                Human in the Loop
              </li>
              <li className="cursor-pointer hover:text-white" onClick={() => scrollToSection("tutorials")}>
                Tutorials
              </li>
              <li className="cursor-pointer hover:text-white" onClick={() => scrollToSection("privacy")}>
                Privacy & Security
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <a 
                  href="/privacy-policy" 
                  className="hover:text-white"
                  rel="noopener"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="/terms-of-service" 
                  className="hover:text-white"
                  rel="noopener"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <p className="text-sm text-white/80">
              Questions? Reach out to our support team
            </p>
            <div className="mt-4">
              <button 
                onClick={() => scrollToSection("pricing")}
                className="text-sm text-white/80 hover:text-white cursor-pointer"
              >
                View Pricing
              </button>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm text-white/60">
          <p>© {new Date().getFullYear()} MLC Consulting - Unmanned Expert SL. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};